// extracted by mini-css-extract-plugin
export default {"container":"STh5g9","waybetter":"P66lFb","waybetterStandard":"vFLG0h","landing":"PoNj9m"};